<script>

let toasts = []

let index = 0

let model = {
  text: '',
  lifetime: 4000
}

let api = {
  show (toast) {
    toast = Object.assign({}, model, {
      index: index++
    }, toast)

    toasts.splice(0, 1)
    toasts.push(toast)

    if (toast.lifetime) {
      setTimeout(() => {
        this.hide(toast)
      }, toast.lifetime)
    }

    return toast
  },
  hide (toast) {
    if (!toast) {
      return toasts.splice(0, 1)[0]
    }

    let i
    let index = toast.index

    toasts.some(function (toast, n) {
      if (toast.index === index) {
        i = n
        return true
      }
    })

    return (typeof i !== 'undefined') && toasts.splice(i, 1)[0]
  }
}

export default {
  name: 'toast',
  props: {
    sidenav: {
      default: false
    }
  },
  data () {
    return {
      toasts
    }
  },
  methods: {
    close (toast) {
      api.hide(toast)
    }
  },
  install (Vue, options) {
    // Set default options
    options = Object.assign(model, options)
    options.name = options.name || 'toast'
    Vue.prototype.$toast = api
    Vue.component(options.name, this)
  }
}

</script>

<template lang="pug">

.toasts(:class="{ sidenav }")
  transition-group(appear, enter-active-class="animated fadeInUp", leave-active-class="animated fadeOutUp", mode="out-in", :duration="{ enter: 450, leave: 150 }")
    .toast(v-for="toast in toasts", :key="toast.index")
      .close(@click="close(toast)")
      span(v-text="$t(toast.text)")

</template>

<style scoped lang="sass">

$navigation-width: 280px
$toast-width: 360px

.toasts
  position: fixed
  left: 50%
  top: 120px
  min-width: $toast-width
  transform: translateX(-50%)
  z-index: 120
  &.sidenav
    padding-left: $navigation-width
    min-width: $toast-width + $navigation-width

.toast
  position: relative
  padding: 25px 15px 25px 15px
  border: 1px solid #00B4DB
  background: $white
  border-radius: 5px
  box-shadow: 0 5px 6px rgba(0, 0, 0, 0.16)
  text-align: center

.close
  position: absolute
  right: 10px
  top: 10px
  width: 18px
  height: 18px
  background: url(assets/close.svg) no-repeat
  background-size: 18px 18px
  cursor: pointer
  transform: rotateZ(45deg)

</style>
